import { wikinaePalette } from '@mirinae/wikinae/modules/defines/styles';

const TextsBubbleStyle = `
    position: absolute;
    padding: 15px;
    border-radius: 5px;
    background-color: ${wikinaePalette.main.darken};
    color: ${wikinaePalette.primary.white};

    :after {
        content: '';
        position: absolute;
        bottom: -8px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 8px 8px 0;
        border-color: ${wikinaePalette.main.darken} transparent transparent transparent;
    }

    b {
        font-weight: 600;
    }
`;

export default TextsBubbleStyle;